var render = function() {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _vm.link
    ? _c(
        _vm.wrapperElement,
        {
          tag: "component",
          staticClass: "c-logo",
          class: "c-logo--" + _vm.variant + " " + _vm.extra
        },
        [
          _vm.variant === "with-text"
            ? _c("a", { attrs: { href: _vm.link } }, [
                _c("span", { staticClass: "c-logo__text t-text-style-mu" }, [
                  _vm._v(_vm._s(_vm.text))
                ]),
                _vm._v(" "),
                _c("img", {
                  staticClass: "c-logo__image",
                  attrs: {
                    src: "/gui/images/mkb-logo.svg",
                    width: "70",
                    height: "17",
                    alt: "",
                    "aria-hidden": "true"
                  }
                })
              ])
            : _c("a", { attrs: { href: _vm.link } }, [
                _c("img", {
                  staticClass: "c-logo__image",
                  attrs: {
                    src: "/gui/images/mkb-logo.svg",
                    width: "162",
                    height: "47",
                    alt: "Till startsidan"
                  }
                })
              ])
        ]
      )
    : _c(
        _vm.wrapperElement,
        {
          tag: "component",
          staticClass: "c-logo",
          class: "c-logo--" + _vm.variant,
          attrs: { extra: _vm.extra }
        },
        [
          _vm.variant === "with-text"
            ? _c("div", [
                _c("span", { staticClass: "c-logo__text t-text-style-mu" }, [
                  _vm._v(_vm._s(_vm.text))
                ]),
                _vm._v(" "),
                _c("img", {
                  staticClass: "c-logo__image",
                  attrs: {
                    src: "/gui/images/mkb-logo.svg",
                    width: "70",
                    height: "17",
                    alt: "",
                    "aria-hidden": "true"
                  }
                })
              ])
            : _c("div", [
                _c("img", {
                  staticClass: "c-logo__image",
                  attrs: {
                    src: "/gui/images/mkb-logo.svg",
                    width: "162",
                    height: "47",
                    alt: _vm.text
                  }
                })
              ])
        ]
      )
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }